import "./FeaturedProducts.scss";
import Card from "../../components/Card/Card";
import { useEffect } from "react";
import { useState } from "react";
import axios from 'axios'
import { RiHome3Fill } from "react-icons/ri";

const FeaturedProducts = ({ type }) => {
  const [selectType, setSelectType] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!type) {
      return;
    }

    const getType = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/get-type?type=${type}`);
        setSelectType(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    getType();
  }, [type]);

  // Sort: in-stock (false) products come first
  // const sortedData = selectType?.slice().sort((a, b) => {
  //   return Number(a.attributes.outofstock) - Number(b.attributes.outofstock);
  // });

  return (
    <div>
      <div className="___heading">
        <h3>
          {type} <em>products</em>{" "}
        </h3>
      </div>
      <div className="f_wrp">
        <div className="f_wrp_in">
          {error
            ? "Wait...!"
            : loading
            ? "loading"
            : selectType?.map((item) => <Card item={item} key={item.id} />)}
        </div>
      </div>
    </div>
  );
};

export default FeaturedProducts;
